import { ApiUser } from 'api/types/ApiUserEnvironment';
import { getUserType } from 'utils/analytics/helpers/getUserType';
import { registerMixpanelProperties } from 'utils/analytics/helpers/mixpanel';
import { deleteCookie } from 'utils/cookies';
import { trackError } from 'utils/trackError';

import { trackEvent } from './trackEvent';

export function trackSignUp(user: ApiUser, method: string) {
  trackEvent('User Signed Up', {
    user_id: user?.id,
    method,
    user_type: getUserType(user),
  });

  if (user?.id) {
    registerMixpanelProperties({
      user_id: user.id,
      user_type: getUserType(user),
    });
  } else {
    trackError('Missing user id after sign up');
  }

  deleteCookie('justSignedUp');
}
